import {AdvancedMarker, Pin, useAdvancedMarkerRef} from "@vis.gl/react-google-maps";
import {useEffect} from "react";

export default function SelectableMarker ({ marker, isSelected, onClick }){
    const [markerRef, advancedMarker] = useAdvancedMarkerRef();

    useEffect(() => {
        if (!advancedMarker) return;

        const el = advancedMarker.content;
        if (!el) return;

        if (isSelected) {
            el.classList.add("animate-bounce");
        } else {
            el.classList.remove("animate-bounce");
        }
    }, [advancedMarker, isSelected]);

    return (
        <AdvancedMarker
            ref={markerRef}
            position={{ lat: marker.lat, lng: marker.lng }}
            zIndex={marker.zIndex}
            onClick={onClick}
        >
            <Pin
                background={marker.color}
                borderColor="#333333"
                glyphColor="#000"
                glyphText={marker.glyphText}
            />
        </AdvancedMarker>
    );
};
